import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigation } from "react-router";

/**
 * A 2 px progress bar at the top while the next page loads (its code chunk on a slow network). Shown only after
 * 150 ms, so fast navigations never flash it; without it a tap on 3G looks dead and people tap again.
 */
export function NavProgress() {
  const { t } = useTranslation();
  const loading = useNavigation().state !== "idle";
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!loading) return;
    const timer = window.setTimeout(() => {
      setVisible(true);
    }, 150);
    return () => {
      window.clearTimeout(timer);
      setVisible(false);
    };
  }, [loading]);

  if (!loading || !visible) return null;
  return (
    <div
      role="progressbar"
      aria-label={t("loading")}
      className="fixed inset-x-0 top-[env(safe-area-inset-top)] z-[60] h-0.5 overflow-hidden"
    >
      <div className="h-0.5 w-2/5 animate-progress rounded-full bg-brand-600" />
    </div>
  );
}
